import React                   from 'react'
import { connect }             from 'react-redux'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import i18n from '../../../i18n'
import Formsy from 'formsy-react'
import Input from '../../forms/Input'

import {mapDispatchToProps} from "../../mapDispatchToProps"
import withBaseComponent from '../../withBaseComponent'


class Answer extends withBaseComponent(React.Component) {
  onSubmit(model) {
    if (this.hasError())
      return

    const additional_credentials = Object.assign({}, model, this.props.account.additional_credentials)

    this.props.accountActions.accountAnswer(this.props.account.id, additional_credentials)
      .catch(res => {
        if(res.status === 409){ // if answer is conflicted
          this.props.accountActions.accountSelect(this.props.account.id)
        }
      })
      .finally(() => {
        this.props.accountActions.accountShow(this.props.account.id).then(() => this.props.toggle && this.props.toggle())
      })
  }

  render() {
    const {additional_credentials, display_name, service} = this.props.account

    if (!additional_credentials)
      return null

    return (
      <Modal isOpen={this.props.isOpen} className={`mfc-modal-normal bank-modal`} centered={true}>
        <Formsy preventExternalInvalidation={true} onChange={this.showErrors} ref="form" className="form" onInvalidSubmit={this.showErrors} onSubmit={(model) => this.onSubmit(model)} onValid={this.enableButton} onInvalid={this.disableButton}>
          <ModalHeader toggle={this.props.toggle}>{display_name || service.name}{i18n.t("bank.answer.notice_title")}</ModalHeader>
          <ModalBody>
            <div className="row no-gutters mfc-new-bank-desc">
              <div className="col-sm-12 info-service">
                <p className="small-desc">
                  {additional_credentials.message}
                </p>
                {additional_credentials.media && <p className="small-desc">
                  <img alt="media" src={`data:${additional_credentials.media.type};base64, ${additional_credentials.media.data}`} />
                </p>}
              </div>
              <div className="form-group col-sm-12 answer">
                <label>{additional_credentials.question}</label>
                <Input name="answer" id="frm-answer"
                  value={additional_credentials.answer || ''}
                  validations="minLength:1"/>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button onClick={this.props.toggle} className="btn mfc-btn-gray medium">{i18n.t('common.cancel')}</Button>
            <button className="btn mfc-btn-blue medium" type="submit">
              {i18n.t('common.save')}
            </button>
          </ModalFooter>
        </Formsy>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Answer)
